var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMasterDataAddIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 23,
    viewBox: "0 0 20 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.0627 2.40371C11.0621 1.85565 10.6716 1.4108 10.1919 1.41157C9.71089 1.41235 9.32207 1.85775 9.32333 2.40651L9.33282 10.5221L2.22888 10.5335C1.74852 10.5336 1.35971 10.979 1.36035 11.5285C1.36161 12.0772 1.75146 12.5214 2.23121 12.5206L9.33514 12.5092L9.34463 20.6247C9.34528 21.1728 9.73513 21.6169 10.2155 21.6169C10.6958 21.6154 11.0847 21.17 11.084 20.6219L11.0745 12.5064L18.1785 12.4949C18.6582 12.4941 19.047 12.0487 19.047 11.5C19.0457 10.9512 18.6559 10.5071 18.1761 10.5078L11.0722 10.5193L11.0627 2.40371Z",
    fill: "currentColor",
    stroke: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterDataAddIcon);
export default __webpack_public_path__ + "static/media/master-data-add-icon.552d703608895f47b92676152593785d.svg";
export { ForwardRef as ReactComponent };